import http from "@/http/aisea/axios";

const resource = "/enterprises/crews/fiscal_years";

/**
 * 船員年度集計API
 */
export default {
  /**
   * @param {number|string} fiscalYear - 年度
   * @returns {Promise}
   */
  fetch(fiscalYear) {
    return http.get(`${resource}/${fiscalYear}/summaries`);
  },
};
